import React from 'react'

import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import HeaderImage from 'images/inline/modal/enter-to-win.svg'
import './BreakGateModals.scss'

/**
 * BreakConversionModal — MUI Dialog replacement for the old
 * submodals/BreakConversionModal.jsx (BR-3138, section 6).
 *
 * `onSignUpClick`/`onHowItWorksClick` are still owned by the caller (as
 * before). Old Modal.jsx wired these itself (Modal.jsx:34-43): sign-up
 * closed the modal then called modalContext's showSignUpModalTab(); how-it-works
 * navigated to /how-it-works then closed. Each new owner of this dialog
 * reimplements the same two steps using its own local open state plus
 * userContext's askToLogin() in place of showSignUpModalTab().
 */
export const BreakConversionModal = ({
  open,
  handleClose,
  onSignUpClick,
  onHowItWorksClick,
}) => {
  const theme = useTheme()
  // BR-3138: see BreakLimitModal.jsx - the old phone-only full-screen layout
  // was targeted via a dead `body[data-modal-type=...]` selector; MUI's
  // `fullScreen` prop is the direct replacement.
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="break-conversion-dialog-title"
      fullScreen={isSmallScreen}
    >
      <DialogContent>
        <div className={`modal-container-top modal-break-conversion`}>
          <button
            className="modal-close"
            onClick={handleClose}
            aria-label="Next"
          ></button>
          <div className={`modal-image-header`}>
            <HeaderImage className={`header-image`} />
          </div>
          <div className={`modal-content-zone`}>
            <h1 id="break-conversion-dialog-title">
              Like what you&apos;re seeing?
            </h1>
            <p>
              Sign up with Dailybreak to get more of the good stuff&mdash;games,
              trivia, points towards entering to win cool prizes. Did we
              mention it&apos;s free?
            </p>
            <a onClick={onSignUpClick} className="btn signup">
              Sign up
            </a>
            <a
              onClick={onHowItWorksClick}
              className={`modal-bottom-link`}
              to="/how-it-works"
            >
              How it works
            </a>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
